export const PhonePausedIcon = () => (
  <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 1.33317L12.5 4.6665" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.1667 1.33317L15.1667 4.6665" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.5787 9.8015L9.83323 10.3335C7.97876 9.4027 6.83323 8.3335 6.16657 6.66683L6.67987 3.91343L5.70958 1.3335L3.89547 1.3335C2.76793 1.3335 1.88076 2.26592 2.09349 3.37322C2.46244 5.29368 3.35424 8.18784 5.4999 10.3335C7.75592 12.5895 10.8953 13.7098 12.9769 14.2379C14.1323 14.5311 15.1666 13.6243 15.1666 12.4323L15.1666 10.7876L12.5787 9.8015Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
